import React, { Suspense } from 'react';
import { Box, Grid, makeStyles } from '@material-ui/core';
import useLearningPlansHook from './useLearningPlansHook';
import styles from './learning-plans.style';
import { withRouter } from '../../../util/router-compatibility';
import { DataGridWithHeaders, Loader } from '@orijinworks/frontend-commons';

const useStyles = makeStyles(styles);

const LearningPlans = () => {
  const classes = useStyles();
  const {
    learningPlans,
    loading,
    columns,
    pageSize,
    refreshLearningPlans,
    shouldShowLearningPlans
  } = useLearningPlansHook(classes);

  if (!shouldShowLearningPlans) {
    return null;
  }

  return (
    <Suspense fallback={<Loader isLoading={true} />}>
      <Grid 
        container 
        item 
        component="div" 
        className={classes.newGridContent}
      >
        <Loader isLoading={loading} />
        <Box className={classes.gridContainer}>
          <DataGridWithHeaders
            title="Learning Plans"
            subtitle="Manage learning plans, configure pillars, and track learner progress across your jurisdiction."
            dataGridProps={{
              columns: columns,
              data: learningPlans,
              pageSize,
              pageSizeOptions: [20, 50, 100],
              paginationMode: 'client',
              isLoading: loading,
              showCheckbox: false,
              onRefreshHandler: refreshLearningPlans,
              tdStyles: classes.tableCellStyles,
            }}
          />
        </Box>
      </Grid>
    </Suspense>
  );
};

export default withRouter(LearningPlans);

